import React from 'react'
import {  useNavigate } from 'react-router-dom'

function Page404() {

    const Navigate = useNavigate()

  return (
    <div className=' text-center flex justify-center items-center w-full h-screen flex-col'>
     <h1 className='text-9xl font-extrabold'>404</h1>
    <p><button onClick={()=>Navigate("/login") } className='bg-blue-950 text-white p-1'> Click to return login page</button></p>
    </div>
  )
}


export default Page404